import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/config";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [msg] = useState("Accesso in corso...");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => navigate("/gestione", { replace: true, state: { user: r.data } }))
      .catch((e) => navigate("/gestione", { replace: true, state: { authError: e.response?.data?.detail || "Accesso con Google non riuscito" } }));
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50" data-testid="auth-callback">
      <p className="flex items-center gap-2 text-slate-600"><Loader2 className="w-5 h-5 animate-spin text-sky-600" /> {msg}</p>
    </div>
  );
}
